import React from "react";

const fmt = (v) => (v === null || v === undefined ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v));
const PROBLEMS = [["required_empty", "Must have a value"], ["missing", "Should have been sent"], ["unexpected", "Sent but not on their list"]];
const NOTES = [["empty", "No answer on this lead"], ["left_out_empty", "Left out because empty"]];

export function CheckBadge({ check, id }) {
  if (!check) return <span className="text-[10px] text-zinc-400" data-testid={`delivery-check-${id}`}>—</span>;
  return (
    <span className={`border border-black px-1.5 py-0.5 text-[9px] uppercase tracking-widest ${check.ok ? "bg-emerald-600 text-white" : "bg-red-600 text-white"}`}
          data-testid={`delivery-check-${id}`}>
      {check.ok ? "Fields OK" : "Check failed"}
    </span>
  );
}

function Lines({ check, rows, tone, p }) {
  return rows.filter(([k]) => check[k]?.length).map(([k, label]) => (
    <div key={k} className={`text-[11px] ${tone}`} data-testid={`${p}-${k}`}><b>{label}:</b> {check[k].join(", ")}</div>
  ));
}

// Exactly what one delivery sent, with how it compares to the buyer's field list.
export function DeliveryReceipt({ attempt }) {
  const c = attempt.field_check || {};
  const rows = Object.entries(attempt.sent_payload || {});
  const p = `delivery-receipt-${attempt.id}`;
  return (
    <div className="space-y-2 font-sans" data-testid={p}>
      <div className="text-xs" data-testid={`${p}-summary`}>
        {c.ok ? `All ${c.sent} fields match what ${attempt.destination_name} should get.` : `This delivery didn't match what ${attempt.destination_name} should get.`}
        {attempt.destination_type === "email" && " Sent as an email, with plain labels instead of these names."}
      </div>
      <Lines check={c} rows={PROBLEMS} tone="text-red-700" p={p} />
      <Lines check={c} rows={NOTES} tone="text-zinc-600" p={p} />
      <div className="max-h-80 overflow-auto border border-black bg-white">
        <table className="w-full text-[11px]">
          <thead>
            <tr className="border-b border-black bg-zinc-100 text-[10px] uppercase tracking-widest">
              <th className="px-2 py-1 text-left">Field as sent</th><th className="px-2 py-1 text-left">Value</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(([k, v]) => (
              <tr key={k} className="border-b border-zinc-200" data-testid={`${p}-row-${k}`}>
                <td className="px-2 py-1 align-top font-mono">{k}</td>
                <td className="break-all px-2 py-1">{fmt(v)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
